import { CustomerDataResponse } from "../types/ClaroMultiBff"
import { MobileInfoResponse } from "../types/IdentificationApi/MobileResponse"

const MOBILE_SITUATIONS = ["ATIVO", "SUSPENSO", "CANCELADO", "PREATIVO"] as const

type MobileSituation = (typeof MOBILE_SITUATIONS)[number]

const normalizeCustomerType = (
  customerType: string
): "owner" | "dependent" => {
  const normalized = customerType?.toLowerCase?.() ?? ""

  if (normalized.includes("depend")) {
    return "dependent"
  }

  return "owner"
}

const normalizeSituation = (situation: string): MobileSituation => {
  const normalized = (situation || "").toUpperCase() as MobileSituation

  return MOBILE_SITUATIONS.includes(normalized) ? normalized : "ATIVO"
}

const normalizeDependentPlanType = (
  planType: string
): "POS_PAGO" | "PRE_PAGO" | "CONTROLE" => {
  const normalized = planType?.toUpperCase?.() ?? ""

  if (normalized.includes("PRE")) {
    return "PRE_PAGO"
  }

  if (normalized.includes("CONTROLE")) {
    return "CONTROLE"
  }

  return "POS_PAGO"
}

export const mapCustomerDataToMobileInfoResponse = (
  session: CustomerDataResponse
): MobileInfoResponse => {
  return {
    data: {
      customerType: normalizeCustomerType(session.customerType),
      situation: normalizeSituation(session.situation),
      planName: session.planName,
      planValue: session.planValue,
      planType: session.planType,
      planId: 0,
      promotionDiscountPlanValue: 0,
      planComponents: "VOZ,DADOS,TORPEDOS",
      dependents: (session.dependents || []).map((dependent) => ({
        msisdn: dependent.msisdn,
        situation: "ATIVO",
        planType: normalizeDependentPlanType(dependent.planType),
        planComponents: ["VOZ", "DADOS", "TORPEDOS"],
      })),
      customerName: session.name,
    },
    meta: {
      code: "200",
      message: "Sucesso",
    },
    code: "200",
    message: "Sucesso",
    statusCode: 200,
  }
}
